import styled from "styled-components";

import { Box } from "atoms";

export const Flex = styled(Box)`
  display: Flex;
`;
